import React from 'react';
import { colors, Paper, SxProps, Typography, Box, Stack, Slide, Backdrop } from '@mui/material';

import { Button } from '../../../../components/core';

interface ActionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed?: () => void;
  isSubmitting?: boolean;
  paperStyles?: SxProps;
  content: {
    heading: string;
    helpingText?: string;
    cancelButtonText: string;
    proceedButtonText: string;
  };
}

export const ActionDialog = ({
  isOpen,
  onClose,
  content,
  onProceed,
  isSubmitting,
  paperStyles,
}: ActionDialogProps) => {
  return (
    <>
      <Slide direction="up" in={isOpen} mountOnEnter unmountOnExit>
        <Paper
          sx={{
            zIndex: 2,
            position: 'absolute',
            margin: 0,
            bottom: 0,
            right: 0,
            border: `1px solid ${colors.grey[300]}`,
            py: 3,
            px: 4,
            width: '100%',
            ...paperStyles,
          }}
        >
          <Stack spacing={2}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '20px',
                color: 'black',
              }}
            >
              {content.heading}
            </Typography>
            <Typography sx={{ fontSize: '14px' }}>{content.helpingText}</Typography>
          </Stack>
          <Box
            sx={{
              mt: 3,
              display: 'flex',
              gap: 2,
              '& button': {
                height: 48,
                width: '100%',
              },
            }}
          >
            <Button
              theme="secondary"
              variant="outlined"
              text={content.cancelButtonText}
              onClick={onClose}
              data-testid="cancel_dialog"
            />
            <Button
              variant="contained"
              onClick={onProceed}
              disabled={isSubmitting}
              loading={isSubmitting}
              data-testid="proceed_dialog"
              text={content.proceedButtonText}
            />
          </Box>
        </Paper>
      </Slide>
      <Backdrop
        onClick={onClose}
        open={isOpen}
        sx={{ zIndex: 1, width: '100%', height: '100%', position: 'absolute', borderRadius: '8px' }}
      />
    </>
  );
};
